import {httpAction, getAction, postAction} from '@/api/manage'
//撤回
export function withdraw(applicationCode,that,record){
  if(applicationCode === 'env_audit'){
    epm_withdraw(that,record);
  }else if(applicationCode === 'ipsys'){
    ipsys_withdraw(that,record)
  }
}
function epm_withdraw(that,record) {
  let map = {}
  map.pfBpmProcessId = record.process_guid;
  map.workNo = that.$store.getters.userInfo.workNo;
  map.approveAction = "Withdraw";
  // map.taskCode = record.task_code;
  map.url="/sys/electronicSigned/envProcess/"+record.processGuid
  map.httptype="Post"
  map.title = that.language['eletronicSigned.withdraw'];
  that.$refs.myTodoCommentsModal.edit(map);
}
function ipsys_withdraw(that,record) {
  let map = {}
  map.processGuid = record.process_guid;
  map.approverUserCode = that.$store.getters.userInfo.workNo;
  map.approveAction = "Withdraw";
  map.taskCode = record.task_code;
  map.url="/sys/electronicSigned/ipsysProcess/"+record.process_guid
  map.httptype="Post"
  map.title = that.language['eletronicSigned.withdraw'];
  that.$refs.myTodoCommentsModal.edit(map);
}